import { httpClient as http } from '../services'
import _ from 'lodash'
import vm from '../main'
import { API } from '../config'

const internals = {}

;(internals.addCity = city => {
  city = Object.assign({}, city)


  return http
    .post('/datacity', city)
    .then(result => {
      return result
    })
    .catch(error => {
      console.error('datacity.inviteUser-error:\n', error)
      throw error
    })
}),
  (internals.updateCity = city => {
    city = Object.assign({}, city)


    const promises = []

    return http
      .put('/updatecity', city)
      .then(result => {
        city = result.data
        return city
        // return Promise.all(promises)
      })
      .catch(error => {
        console.error('datacity.inviteUser-error:\n', error)
        throw error
      })
  })

internals.resetPassword = (_id, password, token) => {
  // ------------------------
  var myHeaders = new Headers()
  myHeaders.append('Authorization', `Bearer ${token}`)
  myHeaders.append('Content-Type', 'application/json;charset=UTF-8')
  myHeaders.append('Accept', 'application/json')

  var raw = {
    user: {
      _id,
      password
    }
  }
  var requestOptions = {
    method: 'PUT',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  }

  // fetch("http://localhost:8085/update-user-pass", requestOptions)
  //   .then(response => response.text())
  //   .then(result => (result))
  //   .catch(error => ('error', error));
  // -------------------------

  let payload = {
    user: {
      _id,
      password
    }
  }
 
  // how to add headers in http below
  return http
    .put('/update-user-pass', payload, null, myHeaders)
    .catch(error => {
      console.error('city.resetPassword-error:\n', error)
      throw error
    })
}

// internals.getCity = (userId) => {
//   return http
//     .get('/datacity/'+userId)
//     .then(response => {
//       return response
//     })
//     .catch(error => {
//       console.error('cityService.getgetCity-error:\n', error)
//       throw error
//     })
// }

// internals.addCity = function (city) {
//     city = (({
// cityName,
// firstName,
// lastName,
// email,
// mobile

//     }) => {
//         return {
//             city,
//             manager,
//             email,
//             mobile

//         }
//     })(city)

//     return vm.$cityDataRepository
//         .create(city)
//         .then(result => {
//             city = result.data
//             return city
//         })
//         .catch(error => {
//             console.error('cityService.createUser-error:\n', error)
//             throw error
//         })
// }

// internals.updateCity = function (city) {
//     city = Object.assign({}, city)
//     city = (({
//       cityName,
//       firstName,
//       lastName,
//       email,
//       mobile

//     }) => {
//         return {
//           cityName,
//           firstName,
//           lastName,
//           email,
//           mobile

//         }
//     })(city)

//     return vm.$cityRepository
//         .update(city._id, city)
//         .then(result => {
//             city = result.data
//             return city
//         })
//         .catch(error => {
//             console.error('cityUpdate.update-error:\n', error)
//             throw error
//         })
// }

internals.citysearch = function(params,searchItem) {
  return http
    .get(`/datacity/search?page=${params.page}&limit=${params.limit}&searchString=${searchItem}`)
    .then(result => {
      return result
    })
    .catch(error => {
      console.error('authService.inviteUser-error:\n', error)
      throw error
    })
}

internals.citystatus = function(id, status) {
  return http.put(API.CITY + '/' + id + '/status' + '/' + status)
}

internals.getById = (Id) => {
  return http
    .get( 'city/' + Id + '?%24embed=user')
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("city-error:\n", error);
      throw error;
    });
};

export default internals



// WEBPACK FOOTER //
// ./src/services/city.service.js